export type FieldType = 'text' | 'date' | 'email' | 'currency' | 'signature'

export type FormField = {
  id: string
  label: string
  type: FieldType
  placeholder?: string
  section: string
}

export const FIELDS: FormField[] = [
  {
    id: 'name',
    label: 'Full Name',
    type: 'text',
    placeholder: 'Jordan A. Rivera',
    section: 'Tenant Information',
  },
  {
    id: 'dob',
    label: 'Date of Birth',
    type: 'date',
    placeholder: 'MM / DD / YYYY',
    section: 'Tenant Information',
  },
  {
    id: 'email',
    label: 'Email Address',
    type: 'email',
    placeholder: 'name@email.com',
    section: 'Tenant Information',
  },
  {
    id: 'address',
    label: 'Address',
    type: 'text',
    placeholder: '1242 Sunset Blvd, Los Angeles, CA',
    section: 'Tenant Information',
  },
  {
    id: 'start',
    label: 'Lease Start Date',
    type: 'date',
    placeholder: 'MM / DD / YYYY',
    section: 'Lease Terms',
  },
  {
    id: 'rent',
    label: 'Monthly Rent',
    type: 'currency',
    placeholder: '$0.00',
    section: 'Lease Terms',
  },
  {
    id: 'signature',
    label: 'Signature',
    type: 'signature',
    section: 'Acknowledgment',
  },
]
